export default "__VITE_ASSET__kY5mN$Bt__"